import { ReactComponent as IconChevron } from '@/assets/svgs/profile-chevron.svg'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@dextech-ai/dex-design-system'
import iconBuilding from '@/assets/svgs/icon-building.svg'

const Profile = ({ label, image, options, handleSelected }) => {
	return (
		<div className="profile">
			<DropdownMenu placement="bottomRight">
				<DropdownMenuTrigger asChild>
					<div className="profile-header">
						<div className="profile-header__left">
							<div className="avatar" style={{ backgroundImage: image ? `url(${image})` : `url(${iconBuilding})` }}></div>
						</div>
						<div className="profile-header__right">
							<div className="profile-header__action">
								<div className="profile-header__name">{label}</div>
								<div className="profile-header__more" data-testid="dropdown-option"><IconChevron /></div>
							</div>
						</div>
					</div>
				</DropdownMenuTrigger>
				<DropdownMenuContent>
					{options?.map((option) => (
						<DropdownMenuItem itemKey={option} key={option} onSelect={() => handleSelected(option)}>
							<span id={option === 'Logout' ? 'logout-id' : 'account-settings-id'}>{option}</span>
						</DropdownMenuItem>
					))}
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
	)
}

export default Profile
